import { DATASET_ROUTES } from "../../../modules/datasets";
import FeatherIcon from "feather-icons-react";
import { Icon } from "@introist/react-foundation/v2";
import { AppMenuItem } from "../shell";
import { useDatasetDefs } from "../../../modules/datasets/hooks/useDatasetDefs";
import { EMPLOYEE_ROUTES } from "../../../modules/employees";

export const useDataStudioMenuItems = (
  handleItemClick: (to: string) => (e: React.MouseEvent) => unknown
) => {
  let items: AppMenuItem[] = [];

  const { datasets } = useDatasetDefs();

  const subItems = (datasets ?? []).map(dataset => ({
    key: dataset.id,
    title: dataset.plural,
    path: DATASET_ROUTES.dataset.path.replace(":id", dataset.id),
    onClick: handleItemClick(DATASET_ROUTES.dataset.path.replace(":id", dataset.id))
  }));

  items.push({
    title: "Employees",
    icon: <Icon name="persons" />,
    path: EMPLOYEE_ROUTES.employees.path,
    onClick: handleItemClick(EMPLOYEE_ROUTES.employees.path)
  });

  items.push({
    title: "Data",
    icon: <FeatherIcon icon="database" size="17px" />,
    closable: false,
    subItems
  });

  return items;
};
